export function sanitizeDescription(html: string): string {
  if (!html) return '';

  // Replace <br> and <br/> with newlines
  let text = html.replace(/<br\s*\/?>/gi, '\n');

  // Replace <ul> and </ul> with newlines
  text = text.replace(/<\/?ul[^>]*>/gi, '\n');

  // Replace <li> with bullet points and </li> with newlines
  text = text.replace(/<li[^>]*>/gi, '• ');
  text = text.replace(/<\/li>/gi, '\n');

  // Remove all other HTML tags
  text = text.replace(/<[^>]+>/g, '');

  // Fix multiple newlines
  text = text.replace(/\n\s*\n\s*\n/g, '\n\n');

  // Trim whitespace
  text = text.trim();

  return text;
}